/**
 * Page title bar. `actions` is where v2 puts screen-level buttons (Deploy,
 * Create site) — the slot exists now so adding them is not a restructure.
 */
export default function PageHeader({ eyebrow, title, lede, meta, actions }) {
  return (
    <header className="pagehead">
      <div className="pagehead__main">
        {eyebrow ? <p className="pagehead__eyebrow">{eyebrow}</p> : null}
        <h1 className="pagehead__title">{title}</h1>
        {lede ? <p className="pagehead__lede">{lede}</p> : null}
      </div>
      {meta || actions ? (
        <div className="pagehead__side">
          {meta ? <div className="pagehead__meta">{meta}</div> : null}
          {actions ? <div className="pagehead__actions">{actions}</div> : null}
        </div>
      ) : null}
    </header>
  );
}
